export const isIOSUIWebView = () =>
  /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(navigator.userAgent);
export const isAndroidWebView = () =>
  /Android.*Version\/\d+.\d+/i.test(navigator.userAgent);
